export const metaTitleDescParenting = {
  hi: {
    metaTitle: 'प्रेगनेंसी और परवरिश के बारे में अधिक जानें | Mylo Family',
    metaDescription:
      'पेरेंटिंग चुनौतीपूर्ण और फायदेमंद दोनों है। बच्चों के जीवन के हर चरण में उनके लिए पेरेंटिंग टिप्स, सकारात्मक पालन-पोषण, सुरक्षा और स्वास्थ्य के बारे में अधिक जानें @MyloFamily',
  },
  bn: {
    metaTitle: 'প্রেগনেন্সি এবং প্যারেন্টিং গাইড | Mylo Family',
    metaDescription:
      'অভিভাবকত্ব উভয়ই চ্যালেঞ্জিং এবং ফলপ্রসূ। বাচ্চাদের জীবনের প্রতিটি পর্যায়ে অভিভাবকত্বের পরামর্শ, ইতিবাচক অভিভাবকত্ব, নিরাপত্তা এবং স্বাস্থ্য সম্পর্কে আরও জানুন @MyloFamily',
  },
  te: {
    metaTitle:
      'ప్రెగ్నెన్సీ  మరియు పేరెంటింగ్ గురించి తెలుసుకోండి | మయిలో ఫ్యామిలీ',
    metaDescription:
      'పేరెంటింగ్ అనేది ఛాలెంజింగ్ మరియుఎంతో అద్భుతంగా కూడా ఉంటుంది. పేరెంటింగ్‎కు సంబంధించిన టిప్స్, పిల్లలను ఎలా పాజిటివ్‎గా తీసుకురాలి, పిల్లల సెక్యూరిటీ మరియు ఆరోగ్యానికి సంబంధించిన విషయాలను ప్రతి దశ వారీగా',
  },
  ta: {
    metaTitle:
      'பிரக்னன்சி மற்றும் பேரண்டிங் பற்றி அறிந்து கொள்க | மைலோ ஃபேமிலி',
    metaDescription:
      'பேரண்டிங் என்பது சற்றே சவாலானது, அதே சமயத்தில் மிகவும் பயனளிக்க கூடியது. குழந்தைகள் வளரும் ஒவ்வொரு கட்டத்திலும் பெற்றோர் பின்பற்ற வேண்டிய பேரண்ரிங் முறை, குழந்தைகளை நேர்மறை சிந்தனைகளோடு வளர்ப்பது, குழந்தைகளின் பாதுகாப்பு மற்றும் ஆரோக்கியம் குறித்த டிப்ஸ்களைப் பற்றி மேலும் கொள்க.',
  },
};
